module.exports = __webpack_public_path__ + "static/shipkoo-express-4-0fd2bf21330ec4489f12d0e20c79ee3a.png";